<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="wrap main_wrap">
    <section id="re_section_1">
      <div :class="`section_bg bg_${currentIndex}`">
        <swiper
          :slidesPerView="1"
          :spaceBetween="30"
          :loop="true"
          :speed="700"
          :touchEventsTarget="true"
          :autoplay="{
            delay: 5000,
            disableOnInteraction: false,
          }"
          :pagination="{
            clickable: true,
          }"
          :navigation="{
            nextEl: '.swiper-button-next-custom',
            prevEl: '.swiper-button-prev-custom',
          }"
          :modules="modules"
          class="newSwiperContents"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            @click="
              moveToUrl('https://metademy.ac/contents?search_type=조종훈련')
            "
          >
            <div class="contents">
              <div class="txt_group bubble new">
                <div>초경량 비행 장치 기초 조종 훈련/시설물 점검</div>
                <div>
                  가상 하늘에서 안전하게,<br />
                  초경량 비행 장치 실습
                </div>
                <div>메타버스 환경으로 구현한 자격과정 기반 실습 콘텐츠</div>
              </div>
              <div class="img_group">
                <!-- <img
                    src="../../public/assets/images/main/re_section_1_3.png"
                    alt=""
                  /> -->
                <img src="../assets/images/main/re_section_1_9.png" alt="" />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide @click="moveToUrl('https://metademy.ac/notice/51')">
            <div class="contents">
              <div class="txt_group bubble update">
                <div style="display: none">물리치료</div>
                <div>
                  새로운 모습,<br />
                  더 강력한 기능!
                </div>
                <div>
                  최신 대규모 업데이트로<br />
                  더욱 놀라운 경험을 선사합니다.<br />
                  <br />
                  지금 확인해보세요!
                </div>
              </div>
              <div class="img_group">
                <!-- <img
                src="../../public/assets/images/main/re_section_1_3.png"
                alt=""
                /> -->
                <img src="../assets/images/main/re_section_1_5.png" alt="" />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide @click="moveToUrl('https://metademy.ac/contents/18')">
            <div class="contents">
              <div class="txt_group bubble new">
                <div>실험동물부검실습(실습/테스트모드)</div>
                <div>
                  소중한 생명을 살리는<br />
                  실험동물 부검 실습
                </div>
                <div>국내 최초 XR 기반 실험동물 부검 실습 특허 출원</div>
              </div>
              <div class="img_group">
                <!-- <img
                    src="../../public/assets/images/main/re_section_1_3.png"
                    alt=""
                  /> -->
                <img src="../assets/images/main/re_section_1_6.png" alt="" />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide @click="moveToUrl('https://metademy.ac/contents/19')">
            <div class="contents">
              <div class="txt_group bubble new">
                <div>요양보호(실습/평가모드)</div>
                <div>
                  언제 어디서나<br />
                  실습 평가를 한번에
                </div>
                <div>가상현실(PC, VR)을 통한 자격증 기반 실습콘텐츠</div>
              </div>
              <div class="img_group">
                <!-- <img
                    src="../../public/assets/images/main/re_section_1_3.png"
                    alt=""
                  /> -->
                <img src="../assets/images/main/re_section_1_7.png" alt="" />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide
            @click="
              moveToUrl('https://metademy.ac/contents?search_txt=서버보안실습')
            "
          >
            <div class="contents">
              <div class="txt_group">
                <div>서버보안실습(진단/관리)</div>
                <div>
                  리눅스 서버<br />
                  운영을 안전하게
                </div>
                <div>시스템 종류별 취약점 진단과 관리 실습은 한번에</div>
              </div>
              <div class="img_group">
                <!-- <img
                    src="../../public/assets/images/main/re_section_1_1.png"
                    alt=""
                  /> -->
                <img src="../assets/images/main/re_section_1_1.png" alt="" />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide
            @click="moveToUrl('https://metademy.ac/contents?search_txt=CTF')"
          >
            <div class="contents">
              <div class="txt_group">
                <div>라온 CTF</div>
                <div>
                  화이트 해커가<br />
                  제작한 해킹보안 솔루션
                </div>
                <div>
                  웹/앱 서비스 해킹 등을 체험하는 실습형 교육 서비스 패키지
                </div>
              </div>
              <div class="img_group">
                <!-- <img
                    src="../../public/assets/images/main/re_section_1_4.png"
                    alt=""
                  /> -->
                <img src="../assets/images/main/re_section_1_4.png" alt="" />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide @click="moveToUrl('https://metademy.ac/contents/3')">
            <div class="contents">
              <div class="txt_group">
                <div>간호술기</div>
                <div>
                  언제 어디서나<br />
                  실습・평가를 한번에
                </div>
                <div>가상현실(VR)을 통한 핵심간호술기 교육 콘텐츠</div>
              </div>
              <div class="img_group">
                <!-- <img
                    src="../../public/assets/images/main/re_section_1_2.png"
                    alt=""
                  /> -->
                <img src="../assets/images/main/re_section_1_2.png" alt="" />
              </div>
            </div>
          </swiper-slide>

          <swiper-slide @click="moveToUrl('https://metademy.ac/contents/4')">
            <div class="contents">
              <div class="txt_group">
                <div>물리치료</div>
                <div>
                  현장감이 증대되는<br />
                  실제 대상 촬영 실습
                </div>
                <div>360º VR 기반의 실감형 물리치료 실습 교육</div>
              </div>
              <div class="img_group">
                <!-- <img
                    src="../../public/assets/images/main/re_section_1_3.png"
                    alt=""
                  /> -->
                <img src="../assets/images/main/re_section_1_3.png" alt="" />
              </div>
            </div>
          </swiper-slide>

          <!-- Add more slides as needed -->
          <div class="swiper-button-prev-custom"></div>
          <div class="swiper-button-next-custom"></div>
        </swiper>
      </div>

      <div class="floating_area">
        <div class="txt">언제 어디서나, 원하는 만큼 현실감 있는 학습을.</div>
      </div>
    </section>

    <section id="re_section_2" class="bg">
      <div class="container">
        <div class="section_title">신규 등록 콘텐츠</div>
        <div v-if="contentsList[contentsList.length - 3]" class="item_group">
          <!-- <a class="item" href="/contents/{{contentsList[contentsList.length - 3].idx}}"> -->
          <a class="item" :href="'/contents/' + contentsList[7].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[7].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="formatTitle(contentsList[7].title)"
                ></div>
                <!-- <div
                  class="title"
                  v-html="
                    formatCTFTitle(contentsList[contentsList.length - 3].title)
                  "
                ></div> -->
                <div
                  class="description"
                  v-html="formatTitle(contentsList[7].summary)"
                ></div>
                <!-- <div class="description">{{contentsList[contentsList.length - 3].summary}}</div> -->
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[7].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>
          <!-- <a
            class="item"
            :href="'/contents/' + contentsList[contentsList.length - 3].idx"
          >
            <div
              class="img_group"
              :style="
                getBackgroundStyle(
                  contentsList[contentsList.length - 3].thumbnail
                )
              "
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="
                    formatTitle(contentsList[contentsList.length - 3].title)
                  "
                ></div>
                
                <div
                  class="description"
                  v-html="
                    formatTitle(contentsList[contentsList.length - 3].summary)
                  "
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[contentsList.length - 3].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a> -->

          <a
            class="item"
            :href="'/contents/' + contentsList[contentsList.length - 2].idx"
          >
            <div
              class="img_group"
              :style="
                getBackgroundStyle(
                  contentsList[contentsList.length - 2].thumbnail
                )
              "
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="
                    formatTitle(contentsList[contentsList.length - 2].title)
                  "
                ></div>
                <!-- <div
                  class="title"
                  v-html="
                    formatCTFTitle(contentsList[contentsList.length - 2].title)
                  "
                ></div> -->
                <div
                  class="description"
                  v-html="
                    formatTitle(contentsList[contentsList.length - 2].summary)
                  "
                ></div>

                <!-- <div class="description">{{contentsList[contentsList.length - 2].summary}}</div> -->
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[contentsList.length - 2].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>

          <a
            class="item"
            :href="'/contents/' + contentsList[contentsList.length - 1].idx"
          >
            <div
              class="img_group"
              :style="
                getBackgroundStyle(
                  contentsList[contentsList.length - 1].thumbnail
                )
              "
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="
                    formatTitle(contentsList[contentsList.length - 1].title)
                  "
                ></div>
                <!-- <div class="txt">
                <div
                  class="title"
                  v-html="
                    formatCTFTitle(contentsList[contentsList.length - 1].title)
                  "
                ></div> -->
                <div
                  class="description"
                  v-html="
                    formatTitle(contentsList[contentsList.length - 1].summary)
                  "
                ></div>
                <!-- <div class="description">{{contentsList[contentsList.length - 1].summary}}</div> -->
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[contentsList.length - 1].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
    <section id="re_section_2">
      <div class="container">
        <div class="section_title">무료 실습 콘텐츠</div>
        <div v-if="contentsList" class="item_group">
          <!-- <a class="item" href="/contents/{{contentsList[0].idx}}"> -->
          <a class="item" :href="'/contents/' + contentsList[0].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[0].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="contentsList[0].title + '_1강 '"
                ></div>
                <!-- <div class="title" v-html="formatCTFTitle(contentsList[0].title) + '강 '"></div> -->
                <!-- <div class="title">{{contentsList[0].title}}_1강</div> -->
                <div
                  class="description"
                  v-html="formatTitle(contentsList[0].summary)"
                ></div>
                <!-- <div class="description">{{contentsList[0].summary}}</div> -->
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[0].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
                <!-- <div  v-for="(keyword, kIndex) in contentsList[0].keyword" :key="kIndex"> -->
                <!-- {{ formatTag(keyword.replace('#', '')) }} -->
                <!-- <div  v-for="(keyword, kIndex) in contentsList[0].keyword" :key="kIndex" v-html="formatTag(keyword)"> -->
                <!-- </div> -->
                <!-- <div  v-for="(keyword, kIndex) in contentsList[0].keyword" :key="kIndex">
                  {{ keyword.replace('#', '') }}
                </div> -->
              </div>
            </div>
          </a>

          <a class="item" :href="'/contents/' + contentsList[1].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[1].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="contentsList[1].title + '_1강 '"
                ></div>
                <div
                  class="description"
                  v-html="formatTitle(contentsList[1].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[1].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
                <!-- <div  v-for="(keyword, kIndex) in contentsList[1].keyword" :key="kIndex">
                  {{ keyword.replace('#', '') }}
                </div> -->
              </div>
            </div>
          </a>

          <a class="item" :href="'/contents/' + contentsList[2].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[2].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="contentsList[2].title + '_1강 '"
                ></div>
                <div
                  class="description"
                  v-html="formatTitle(contentsList[2].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[2].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>
          <a class="item" :href="'/contents/' + contentsList[3].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[3].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="contentsList[3].title + '_1강 '"
                ></div>
                <div
                  class="description"
                  v-html="formatTitle(contentsList[3].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[3].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>
          <a class="item" :href="'/contents/' + contentsList[0].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[0].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="contentsList[0].title + '_2강 '"
                ></div>
                <div
                  class="description"
                  v-html="formatTitle(contentsList[0].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[0].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>
          <a class="item" :href="'/contents/' + contentsList[1].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[1].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="contentsList[1].title + '_2강 '"
                ></div>
                <div
                  class="description"
                  v-html="formatTitle(contentsList[1].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[1].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="container">
        <div class="section_title">인기 실습 콘텐츠</div>
        <div v-if="contentsList" class="item_group">
          <a class="item" :href="'/contents/' + contentsList[4].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[4].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="formatTitle(contentsList[4].title)"
                ></div>
                <!-- <div
                  class="title"
                  v-html="formatCTFTitle(contentsList[4].title)"
                ></div> -->
                <div
                  class="description"
                  v-html="formatTitle(contentsList[4].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[4].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>
          <a class="item" :href="'/contents/' + contentsList[5].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[5].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="formatTitle(contentsList[5].title)"
                ></div>
                <!-- <div
                  class="title"
                  v-html="formatCTFTitle(contentsList[5].title)"
                ></div> -->
                <div
                  class="description"
                  v-html="formatTitle(contentsList[5].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[5].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>
          <a class="item" :href="'/contents/' + contentsList[6].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[6].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div
                  class="title"
                  v-html="formatTitle(contentsList[6].title)"
                ></div>
                <!-- <div
                  class="title"
                  v-html="formatCTFTitle(contentsList[6].title)"
                ></div> -->
                <div
                  class="description"
                  v-html="formatTitle(contentsList[6].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[6].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>
          <a class="item" :href="'/contents/' + contentsList[3].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[3].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div class="title" v-html="contentsList[3].title"></div>
                <div
                  class="description"
                  v-html="formatTitle(contentsList[3].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[3].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>

          <a class="item" :href="'/contents/' + contentsList[0].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[0].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div class="title" v-html="contentsList[0].title"></div>
                <div
                  class="description"
                  v-html="formatTitle(contentsList[0].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[0].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>

          <a class="item" :href="'/contents/' + contentsList[1].idx">
            <div
              class="img_group"
              :style="getBackgroundStyle(contentsList[1].thumbnail)"
            ></div>
            <div class="info_group">
              <div class="txt">
                <div class="title" v-html="contentsList[1].title"></div>
                <div
                  class="description"
                  v-html="formatTitle(contentsList[1].summary)"
                ></div>
              </div>
              <div class="tag">
                <div
                  v-for="(keyword, kIndex) in formatTag(
                    contentsList[1].keyword
                  )"
                  :key="kIndex"
                  v-html="keyword"
                ></div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>

    <section id="re_section_4">
      <div class="container">
        <div class="section_title">카테고리 찾아보기</div>
        <div class="link_group">
          <a class="link" @click="moveCategory('IT')">
            <div class="img_group">
              <img src="/assets/images/main/cat_menu_security.png" />
            </div>
            <div class="txt_group">해킹·보안</div>
          </a>

          <a class="link" @click="moveCategory('IT')">
            <div class="img_group">
              <img src="/assets/images/main/cat_menu_server.png" />
            </div>
            <div class="txt_group">서버보안</div>
          </a>

          <a class="link" @click="moveCategory('헬스케어')">
            <div class="img_group">
              <img src="/assets/images/main/cat_menu_nurse.png" />
            </div>
            <div class="txt_group">헬스케어</div>
          </a>

          <a class="link" @click="moveCategory('조종훈련')">
            <div class="img_group">
              <img src="/assets/images/main/cat_menu_control.png" />
            </div>
            <div class="txt_group">조종훈련</div>
          </a>
        </div>
      </div>
    </section>

    <section id="re_section_5">
      <div class="section_header">
        <div class="title">What’s RAON Metademy?</div>
        <div class="subTitle">
          반복적인 연습, 실제와 같은 실습형 교육을 강의실 밖에서도 언제
          어디서나.
        </div>
      </div>

      <div class="container">
        <div class="video youtube">
          <iframe
            width="898"
            height="605"
            top="0"
            src="https://www.youtube.com/embed/JFToP246hds?rel=0&autoplay=1&mute=1&loop=1&playlist=JFToP246hds&modestbranding=1&controls=0&vq=hd1080"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <!-- <iframe
            width="898"
            height="604"
            src="https://www.youtube.com/embed/11aEOMAAm6M?rel=0&autoplay=1&mute=1&loop=1&playlist=11aEOMAAm6M&modestbranding=0&vq=hd1080"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe> -->
        </div>
        <div class="section_footer">
          라온 메타데미는 다양한 실습형 학습환경을 제공합니다. 콘텐츠를 관리하는
          관리자는 메타버스 환경에서<br />
          손쉽게 실습형 교육 프로그램을 업로드할 수 있고, 학습자는 실제와 같은
          실습을 반복적으로 경험할 수 있습니다.
        </div>
      </div>
    </section>

    <section id="re_section_6">
      <div class="section_header">
        <div class="title">실감 나는 체험형 실습 콘텐츠</div>
        <div class="subTitle">
          IT 보안 실습, 간호술기 등 완성도 높고 다양한 실습 콘텐츠를 통해 폭
          넓은 학습을 지원합니다.
        </div>
      </div>

      <div class="section_body">
        <div class="container">
          <div class="img_group">
            <img src="/assets/images/main/re_section_6_img.png" />
          </div>
        </div>
      </div>
      >
    </section>
    <section id="re_section_7">
      <div class="section_body">
        <div class="container">
          <div class="contents_group">
            <div>
              <div class="img_group">
                <img src="/assets/images/main/re_section_7_1_img.png" />
              </div>
              <div class="txt_group">
                <div class="title">
                  학습자 및 학습과정 관리를 제공하는<br />
                  블록체인 기반 DID 인증 체계.
                </div>
                <div class="subTitle">
                  라온 메타데미는 학습자의 신원인증과 교육과정 관리를<br />
                  블록체인으로 안전하게 제공합니다. 학습자는 블록체인<br />
                  DID 기술을 활용한 신원인증으로 로그인하며, 학습<br />
                  완료 시 DID 인증을 통해 위변조가 불가능한 수료증을<br />
                  획득하여 학습자 관리를 강화합니다.
                </div>
              </div>
            </div>
            <div>
              <div class="txt_group">
                <div class="title">
                  새로운 디지털 자격 증명 수단,<br />
                  라온 메타데미 옴니원 배지
                </div>
                <div class="subTitle">
                  라온 메타데미에서 실습을 성공적으로 완료한<br />
                  수강생에게 옴니원 배지를 수여합니다.<br />
                  옴니원 배지를 통하여 수강생들은 학습 포트폴리오를<br />
                  스스로 관리 할 수 있고, SNS등 온라인 공간에서 쉽고<br />
                  편리하게 개인 수강이력을 증명, 공유할 수 있습니다.<br />
                  이를 통하여 수강생들이 학습에 몰입 할 수 있게<br />
                  동기 부여와 큰 성취감을 제공합니다.
                </div>
              </div>
              <div class="img_group">
                <img src="/assets/images/main/re_section_7_2_img.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <div class="floating_top" onclick="scrollToTop();">
      <img src="/assets/images/icon/icon-top-button.svg" alt="" />
    </div> -->

    <!-- <div class="floating_top" @click="scrollToTop()">
      <img src="/assets/images/icon/icon-top-button.svg" alt="" />
    </div> -->
    <div>
      <ScrollToTop :initialBottom="140" :isIndexView="true" />
    </div>
    <div class="floating">
      <div class="btn-area">
        <p class="description">
          지금 다운로드 받아 라온 메타데미를 경험해 보세요.
        </p>

        <div>
          <a href="/download">
            <p>다운로드</p>
            <img src="/assets/images/icon/icon-down.png" alt="" />
          </a>
        </div>
      </div>
    </div>

    <div>
      <ModalAlertLogout
        :alertMsg="errMsg"
        :isOpen="errStatus"
        @update:isOpen="updateStatus"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { testAxiosGet, loadContentsList } from '../api/index.js'
import { loadContent } from '../api/boards.js'
import ModalAlertLogout from '../components/ModalAlertLogout.vue'
import ScrollToTop from '../components/ScrollToTop.vue'

// Import Swiper Vue.js components
// import required modules
// Import Swiper styles
import 'swiper/css'

import 'swiper/css/pagination'
import 'swiper/css/navigation'

export default {
  name: 'IndexViews',
  components: {
    Swiper,
    SwiperSlide,
    ModalAlertLogout,
    ScrollToTop,
  },
  setup() {
    const router = useRouter()

    const errMsg = ref('')
    const errStatus = ref(false)

    const updateStatus = () => {
      errStatus.value = false
    }

    const contentsList = ref('')

    const loadContents = async () => {
      const contentRes = await loadContentsList()
      contentsList.value = contentRes.content
    }

    const getBackgroundStyle = (url) => ({
      background: `url(${url}) no-repeat center`,
      backgroundSize: 'cover',
    })

    const formatCTFTitle = (title) => {
      const words = title.split(' ')
      return `${words[0]} ${words[1]}<br>${words.slice(2).join(' ')}`
    }
    // const formatTitle = (title) => {
    //   const words = title
    //   return `${words}`
    // }
    const formatTitle = (title) => {
      const words = title
      if (words.includes('CTF')) {
        const setWords = words.split(' ')
        return `${setWords[0]} ${setWords[1]}<br>${setWords.slice(2).join(' ')}`
      }
      return `${words}`
    }
    const decodeHTMLEntities = (text) => {
      const element = document.createElement('div')
      if (text) {
        element.innerHTML = text
      }
      return element.textContent || element.innerText || ''
    }

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
    const formatTag = (tags) =>
      tags.map((tag) => decodeHTMLEntities(tag.replace('#', '')))

    // const clickCategory = (searchCategory) => {
    //   console.log("clickCategory 진입");
    //   router.push({
    //     path: '/contents',
    //     name: "ContentViews",
    //     query: {
    //       search_type: searchCategory,
    //     },
    //   });
    // };

    // const getresulContent = async() =>{
    //   await loadContent(0, null, searchCategory);
    // }
    const moveCategory = async (searchCategory) => {
      router.push({
        path: '/contents',
        name: 'ContentViews',
        query: {
          search_type: searchCategory,
        },
      })
      await loadContent(0, searchCategory, null)
    }

    const loadToken = async () => {
      const checkToken = testAxiosGet()
      if (checkToken === 404) {
        errStatus.value = true
        errMsg.value =
          '로그아웃되었습니다.<br> 서비스 사용을 원하시면 다시 로그인해 주세요.'
      }
    }
    onMounted(() => {
      // testAxiosGet()
      loadToken()
      loadContents()
    })
    const callFunction = () => {
      testAxiosGet()
    }

    const currentIndex = ref(0)
    const onSlideChange = (swiper) => {
      currentIndex.value = swiper.realIndex + 1
    }

    const moveToUrl = (url) => {
      // console.log(url)
      const urlObj = new URL(url, window.location.origin)
      // path와 query 파라미터 추출
      const urlObjPath = urlObj.pathname
      const queryParams = {}
      // 쿼리 파라미터가 있는 경우, queryParams 객체에 저장
      urlObj.searchParams.forEach((value, key) => {
        queryParams[key] = value
      })
      if (Object.keys(queryParams).length > 0) {
        // 쿼리 파라미터가 있으면 query 객체를 사용
        router.push({
          path: urlObjPath,
          query: queryParams,
        })
      } else {
        // 쿼리 파라미터가 없으면 단순히 path만 사용
        router.push({ path: urlObjPath })
      }
    }

    return {
      contentsList,
      callFunction,
      getBackgroundStyle,
      formatCTFTitle,
      formatTitle,
      formatTag,
      moveCategory,
      scrollToTop,
      modules: [Pagination, Navigation, Autoplay],
      currentIndex,
      onSlideChange,
      moveToUrl,

      errMsg,
      errStatus,
      updateStatus,
    }
  },
}
</script>
<style>
/* 기본 Swiper 스타일을 덮어쓰거나 추가할 수 있습니다. */
#re_section_1 .swiper .swiper-slide {
  cursor: pointer;
}
#re_section_1 .swiper-button-prev-custom,
#re_section_1 .swiper-button-next-custom {
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  cursor: pointer;
  z-index: 9;

  background-size: contain;
  width: 56px;
  height: 56px;
}

#re_section_1 .swiper-button-prev-custom {
  background-image: url('../assets/images/layout/swiper_left.png');
  left: 112px;
}

#re_section_1 .swiper-button-next-custom {
  background-image: url('../assets/images/layout/swiper_right.png');

  right: 112px;
}
</style>
